import {useLayoutEffect, useRef} from 'react';

import LogoIcon from '@/assets/icons/logo-loader.svg?react';
import {DEBUG} from '@/shared/config';

const PAGE_LOADER_EXIT_TOTAL_MS = 320;

function createPageLoaderExitClone(sourceElement: HTMLDivElement): void {
  const clonedNode = sourceElement.cloneNode(true);
  if (!(clonedNode instanceof HTMLDivElement)) {
    return;
  }

  for (const existingClone of document.querySelectorAll<HTMLElement>(
    '[data-page-loader-exit-clone="true"]'
  )) {
    existingClone.remove();
  }

  clonedNode.dataset.pageLoaderExitClone = 'true';
  clonedNode.setAttribute('aria-hidden', 'true');
  clonedNode.classList.add('page-loader-exit-clone');

  document.body.append(clonedNode);

  setTimeout(() => {
    clonedNode.remove();
  }, PAGE_LOADER_EXIT_TOTAL_MS + 100);

  requestAnimationFrame(() => {
    clonedNode.classList.add('page-loader-exit-clone-active');
  });
}

export default function InitLoader() {
  const rootRef = useRef<HTMLDivElement | null>(null);
  const skipDevStrictCleanupRef = useRef<boolean>(DEBUG);

  useLayoutEffect(() => {
    return () => {
      if (skipDevStrictCleanupRef.current) {
        skipDevStrictCleanupRef.current = false;
        return;
      }

      const rootElement = rootRef.current;
      if (!rootElement) {
        return;
      }

      createPageLoaderExitClone(rootElement);
    };
  }, []);

  return (
    <div
      ref={rootRef}
      className="flex h-dvh w-full items-center justify-center bg-white"
      role="status"
    >
      <LogoIcon className="loader-pulse-logo h-20 w-32 text-primary" />
    </div>
  );
}
